import { render, staticRenderFns } from "./DhmeAssemblyHallDashboard.vue?vue&type=template&id=1f2a7865&scoped=true"
import script from "./DhmeAssemblyHallDashboard.vue?vue&type=script&lang=js"
export * from "./DhmeAssemblyHallDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2a7865",
  null
  
)

export default component.exports